import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {UrlModel} from '../../../common/services/url/url.model';
import {FormulaireService} from '../../../common/services/formulaire/formulaire.service';
import {FormModel, FormState} from '../../../common/components/form/models';
import {SubSink} from '@Common/core/utils/subsink';
import {MatSelectChange} from '@angular/material/select';
import {IndividuService} from '@Common/core/services';
import {concatMap, finalize} from 'rxjs/operators';
import {roles} from '../../../common/enum/roles';
import {
  ModaleRenduFormulaireComponent
} from '../../formulaires-liste/rendu-formulaire/modale-rendu-formulaire-container/modale-rendu-formulaire.component';
import {MatDialog} from '@angular/material/dialog';
import {HelperService} from '../../../common/services/helper.service';
import {StatesFormService} from '../../../common/services/states/states-form.service';
import {DomSanitizer} from '@angular/platform-browser';
import {SafeHtmlPipe} from '@Common/widgets/pipes';

@Component({
  selector: 'app-url-edit',
  templateUrl: './url-edit.component.html',
  styleUrls: ['./url-edit.component.scss']
})
export class UrlEditComponent implements OnInit, OnDestroy {
  @Input() urlForm: UrlModel;
  /**
   * Changement de formulaire, envoie [currentForm, newForm]
   */
  @Output() onChangedForm: EventEmitter<[FormModel, FormModel]> = new EventEmitter<[FormModel, FormModel]>();
  forms: FormModel[] = [];
  formSelected: FormModel;
  loading = false;
  subSink = new SubSink();
  constructor(private dialog: MatDialog,
              private sanitized: DomSanitizer,
              private helperSvc: HelperService,
              private individuService: IndividuService,
              public statsFormSvc: StatesFormService,
              public formSvc: FormulaireService) { }

  ngOnInit(): void {
    this._getFormsGestionnaire();
  }
  getStyleStateForm(form: FormModel) {
    const color = this.statsFormSvc.getStateModel(form?.state).color || 'white';
    return `background-color: ${color}; border-radius: 10px; padding: 5px; color: white;`;
  }
  private _getFormsGestionnaire() {
    this.formSelected = null;
    const extraParams = new Map<string, string>([
      ['form_state_in', `${FormState.published.toString()},${FormState.offline.toString()}`]]);
    this.loading = true;
    this.subSink.sink = this.individuService
      .individu$
      .pipe(
        concatMap((_individu) => {
          if (! this.individuService.hasRole(_individu, roles.admin)) {
            extraParams.set('by_gestionnaire', _individu.uid);
          }
          return this.formSvc
            .getFormsSimple(extraParams)
            .pipe(finalize(() => this.loading = false));
        }))
      .subscribe(_forms => {
        this.formSelected = _forms.list.find(_form => _form.id === this.urlForm.form);
        this.forms = _forms.list;
      });
  }
  onSelect(value: MatSelectChange) {
    console.log(value.value);
  }
  changeFormUrl() {
    this.onChangedForm.emit([this.urlForm.form_obj, this.formSelected]);
  }
  close() {
    this.onChangedForm.emit( [null, null]);
  }
  isPreviewDisabled() {
    return this.loading || !this.formSelected;
  }
  isMappingDisabled() {
    return this.formSelected?.id === this.urlForm.form;
  }
  labelCurrentForm(form: FormModel) {
    if (form.id === this.urlForm.form) {
      const sp: SafeHtmlPipe = new SafeHtmlPipe(this.sanitized);
      return sp.transform('<i>(actuel)</i>');
    }
    return '';
  }
  /**
   * Ouverture modale de prévisualisation - sans cadre gestion - s'adapte à l'écran
   * @private
   */
  public visualize() {
    const [screenHeight, screenWidth] = this.helperSvc.getScreenSize();
    const top = 50;
    const width = screenWidth - 50;
    const height = screenHeight - (2 * top);
    const dialogRef = this.dialog.open(ModaleRenduFormulaireComponent, {
      width: '680px',
      data: this.formSelected,
    });
    dialogRef.updatePosition({top: `${top}px`});
    dialogRef.updateSize(`${width}px`, `${height}px`);
  }
  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }
}
